/* ============================================================
   NORTHSHEEP — sideways product row (related products "Slider" layout)

   Markup, inside a host [data-ns-srow]:
     [data-ns-srow-track]   the row that scrolls
     [data-ns-srow-arrows]  prev/next ([data-ns-srow-prev] / [data-ns-srow-next])
     [data-ns-srow-bar]     the slim position bar, thumb as its first child

   Everything is looked up from the event and never held: Dawn's
   <product-recommendations> fills itself in AFTER load by replacing its
   innerHTML, so any element bound at start-up would be gone. A
   MutationObserver on each host re-syncs once the cards arrive.

   No scroll-snap: in this theme snapping has twice been what dragged a row
   back and "broke" scrolling (see CLAUDE.md).
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsScrollRow) return;
  window.__nsScrollRow = true;

  function parts(host) {
    return {
      track: host.querySelector('[data-ns-srow-track]'),
      arrows: host.querySelector('[data-ns-srow-arrows]'),
      prev: host.querySelector('[data-ns-srow-prev]'),
      next: host.querySelector('[data-ns-srow-next]'),
      bar: host.querySelector('[data-ns-srow-bar]'),
    };
  }

  function sync(host) {
    var p = parts(host);
    if (!p.track) return;
    var max = p.track.scrollWidth - p.track.clientWidth;
    var scrollable = max > 2;
    if (p.arrows) p.arrows.hidden = !scrollable;
    if (p.bar) p.bar.hidden = !scrollable;
    if (!scrollable) return;
    var pos = Math.min(1, Math.max(0, p.track.scrollLeft / max));
    if (p.prev) p.prev.disabled = pos <= 0.001;
    if (p.next) p.next.disabled = pos >= 0.999;
    if (p.bar && p.bar.firstElementChild) {
      var trackW = p.bar.clientWidth;
      var thumbW = Math.max(40, Math.round(trackW * (p.track.clientWidth / p.track.scrollWidth)));
      p.bar.firstElementChild.style.width = thumbW + 'px';
      p.bar.firstElementChild.style.transform = 'translateX(' + ((trackW - thumbW) * pos).toFixed(1) + 'px)';
    }
  }

  function syncAll() {
    var hosts = document.querySelectorAll('[data-ns-srow]');
    for (var i = 0; i < hosts.length; i++) sync(hosts[i]);
  }

  /* Rows whose cards are built by JavaScript need to say so. The observer in
     watch() only sees each host's DIRECT children — that is enough for
     <product-recommendations>, which replaces its own innerHTML, but not for
     recently viewed, which writes its <li>s into the track further down. Those
     call this once their cards are in; without it the arrows stay hidden and
     the bar never sizes, because scrollWidth was still 0 at start-up. */
  window.nsScrollRowSync = syncAll;

  // Follow the row as it scrolls (scroll does not bubble; capture does).
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('[data-ns-srow-track]')) {
        var host = t.closest('[data-ns-srow]');
        if (host) sync(host);
      }
    },
    { capture: true, passive: true }
  );

  // Arrows: one view's width per press, smoothly.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ns-srow-prev], [data-ns-srow-next]');
    if (!btn) return;
    var host = btn.closest('[data-ns-srow]');
    var track = host && host.querySelector('[data-ns-srow-track]');
    if (!track) return;
    var dir = btn.hasAttribute('data-ns-srow-next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' });
  });

  // The bar: drag the thumb, or press the track to jump there.
  document.addEventListener('pointerdown', function (e) {
    var bar = e.target.closest && e.target.closest('[data-ns-srow-bar]');
    if (!bar || e.button > 0) return;
    var host = bar.closest('[data-ns-srow]');
    var track = host && host.querySelector('[data-ns-srow-track]');
    var thumb = bar.firstElementChild;
    if (!track || !thumb) return;
    e.preventDefault();
    var rect = bar.getBoundingClientRect();
    var thumbW = thumb.offsetWidth;
    var grab = e.target === thumb ? e.clientX - thumb.getBoundingClientRect().left : thumbW / 2;
    var span = rect.width - thumbW;
    function moveTo(x) {
      if (span <= 0) return;
      var p = Math.min(1, Math.max(0, (x - rect.left - grab) / span));
      track.scrollLeft = p * (track.scrollWidth - track.clientWidth);
    }
    function onMove(ev) { moveTo(ev.clientX); }
    /* A drag on the bar is the shopper's own move: the photo strip's
       no-writes-during-a-swipe guard lets it through (audit E8, 2 Oct 2026). */
    track.__nsBarDrag = true;
    function onUp() {
      track.__nsBarDrag = false;
      bar.classList.remove('is-dragging');
      bar.removeEventListener('pointermove', onMove);
      bar.removeEventListener('pointerup', onUp);
      bar.removeEventListener('pointercancel', onUp);
    }
    bar.addEventListener('pointermove', onMove);
    bar.addEventListener('pointerup', onUp);
    bar.addEventListener('pointercancel', onUp);
    bar.classList.add('is-dragging');
    moveTo(e.clientX);
    try { bar.setPointerCapture(e.pointerId); } catch (err) {}
  });

  /* SCROLL INSIDE THE ROW WITH A MOUSE (owner, 8 Oct 2026, the six-card
     "Often bought together": "can you allows scroll inside the upsell box for
     showing other products"). Only on hosts marked data-ns-srow-grab.
     - The wheel moves the row sideways while the pointer is on it; at either
       end it hands the wheel back, so the page scrolls on as before.
     - A mouse can grab the row and drag it. A drag of more than 6px is not a
       click, so it never opens the card it started on. Fingers and pens keep
       the browser's own swipe.
     Bound on each host, not the document: a non-passive wheel listener on
     the document makes every wheel scroll on every page wait for the main
     thread (audit, 23 Sep 2026 - ns-cart-upsells.js does the same). */
  function onWheel(e) {
    var track = e.target.closest && e.target.closest('[data-ns-srow-track]');
    if (!track || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    var max = track.scrollWidth - track.clientWidth;
    if (max <= 1) return;
    if ((e.deltaY < 0 && track.scrollLeft <= 0) || (e.deltaY > 0 && track.scrollLeft >= max - 1)) return;
    track.scrollLeft += e.deltaY * 1.6;
    e.preventDefault();
  }

  function onGrab(e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var track = e.target.closest && e.target.closest('[data-ns-srow-track]');
    if (!track || e.target.closest('button')) return;
    if (track.scrollWidth - track.clientWidth <= 1) return;
    var startX = e.clientX;
    var startLeft = track.scrollLeft;
    var moved = false;
    function onMove(ev) {
      var dx = ev.clientX - startX;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) {
        moved = true;
        track.classList.add('is-grabbing');
      }
      track.scrollLeft = startLeft - dx;
      ev.preventDefault();
    }
    function onUp() {
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);
      track.classList.remove('is-grabbing');
      if (moved) {
        // The click that ends a drag opens nothing. It comes straight after
        // this pointerup or not at all (released outside the row), so the
        // guard only lives until the next task.
        var stop = function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
        };
        track.addEventListener('click', stop, true);
        setTimeout(function () {
          track.removeEventListener('click', stop, true);
        }, 0);
      }
    }
    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp);
    document.addEventListener('pointercancel', onUp);
  }

  function watch() {
    var hosts = document.querySelectorAll('[data-ns-srow]');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].hasAttribute('data-ns-srow-grab') && !hosts[i].__nsSrowGrab) {
        hosts[i].__nsSrowGrab = true;
        hosts[i].addEventListener('wheel', onWheel, { passive: false });
        hosts[i].addEventListener('pointerdown', onGrab);
        hosts[i].addEventListener('dragstart', function (ev) {
          if (ev.target.closest && ev.target.closest('[data-ns-srow-track]')) ev.preventDefault();
        });
      }
      if (hosts[i].__nsSrowWatched || !('MutationObserver' in window)) continue;
      hosts[i].__nsSrowWatched = true;
      new MutationObserver(function (list) {
        sync(list[0].target.closest('[data-ns-srow]') || list[0].target);
      }).observe(hosts[i], { childList: true });
    }
    syncAll();
  }

  var t = null;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(syncAll, 120);
  });
  window.addEventListener('load', syncAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  /* A colour swap (ns-colour-siblings.js) replaces <main> with a new product's
     rows, and this file, run again, stops at the guard at the top. Unwatched,
     the related row filled in its cards later with nobody to show its arrows
     (audit, 23 Sep 2026). The swap announces itself; watch the new rows. */
  document.addEventListener('ns:colour-swapped', watch);
})();
